export class cUser {
	constructor() {
		
		//construct with some default User values, we can override them later.
		this.info = {}
		this.info.date_format = 'mm/dd/yy';
		this.info.today_as_format = new Intl.DateTimeFormat('en-US').format(new Date());
		
	}
	
	set_user(user) {
		this.info = user;
		var d = new Date();

		var month = d.getMonth() + 1; // Months are 0-indexed
		var day = d.getDate();
		var year = d.getFullYear();

		// Pad with leading zeros if single digits
		if (month < 10) month = '0' + month;
		if (day < 10) day = '0' + day;
		
		switch(this.info.date_format){
			case 'm/d/Y':
				this.info.date_format = 'mm/dd/yy';
				this.info.today_as_format = month + '/' + day + '/' + year;
				break;
			case 'd/m/Y':
				this.info.date_format = 'dd/mm/yy';
				this.info.today_as_format = day + '/' + month + '/' + year;
				break;
			case 'Y/m/d':
				this.info.date_format = 'yy/mm/dd';
				this.info.today_as_format = year + '/' + month + '/' + day;
				break;
			default:
				this.info.date_format = 'mm/dd/yy';
				this.info.today_as_format = month + '/' + day + '/' + year;
				break;
		}
		
	}
	
}